export function isPromise(obj) {
	return typeof obj === 'object' && 'then' in obj && typeof obj.then === 'function'
}

export function awaitDynamicPromiseArray(promises, callback, length = 0, loop = 0) {
	const MAX_LOOPS = 10

	if (length === promises.length || loop >= MAX_LOOPS) {
		return callback()
	}

	const currentLength = promises.length
	Promise.allSettled(promises).then(() => {
		awaitDynamicPromiseArray(promises, callback, currentLength, loop + 1)
	})
}

export class UnscopedPromise {
	constructor() {
		this.resolved = false
		this.rejected = false

		this.promise = new Promise((resolve, reject) => {
			this.resolve = () => {
				this.resolved = true
				resolve()
			}
			this.reject = (e) => {
				this.rejected = true
				reject(e)
			}
		})
	}
}

export function debounce(fn, delay = 128, callFuncOnCreate) {
	let timeout = null

	return function (...args) {
		const context = this

		clearTimeout(timeout)

		const timeoutDelay = callFuncOnCreate && !timeout ? 0 : delay

		timeout = setTimeout(() => {
			fn.apply(context, args)
		}, timeoutDelay)
	}
}

export function throttle(fn, delay, _options) {
	const options = { leading: true, trailing: true, ...(_options ?? {}) }

	let previousExecTimestamp = 0
	let timeoutID = null

	return function (...args) {
		const timestamp = new Date().getTime()

		const leadingExecution = () => {
			previousExecTimestamp = timestamp
			fn.apply(this, args)
		}

		const trailingExecution = () => {
			timeoutID = null
			leadingExecution()
		}

		if (options.leading && timestamp - previousExecTimestamp >= delay) {
			leadingExecution()
		} else if (options.trailing) {
			clearTimeout(timeoutID)
			timeoutID = setTimeout(trailingExecution, delay)
		}
	}
}

export function rafThrottle(fn) {
	let id = null

	return function (...args) {
		if (!id) {
			fn(...args)

			id = window.requestAnimationFrame(() => {
				id = null
			})
		}
	}
}

export function rafDebounce(fn) {
	let raf = null

	return function (...args) {
		const context = this

		cancelAnimationFrame(raf)
		raf = requestAnimationFrame(() => fn.apply(context, args))
	}
}

export function sleep(time) {
	return new Promise((resolve) => setTimeout(resolve, time))
}
